import CloseIcon from '@mui/icons-material/Close';
import ErrorOutline from '@mui/icons-material/ErrorOutlineOutlined';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import type { Theme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import { PropsWithChildren } from 'react';

import { Sxable } from 'library/types';

interface ErrorDialogProps extends Sxable {
	title: string;
	onClose: () => void;
	open?: boolean;
}

export const ErrorDialog = ({
	title,
	onClose,
	children,
	open = true,
	sx = [],
}: PropsWithChildren<ErrorDialogProps>) => {
	const fullScreen = useMediaQuery((theme: Theme) =>
		theme.breakpoints.only('xs')
	);

	return (
		<Dialog open={open} onClose={onClose} fullScreen={fullScreen} sx={sx}>
			<DialogTitle
				sx={{
					display: 'flex',
					alignItems: 'center',
					bgcolor: 'error.main',
					color: 'error.contrastText',
					pr: 7,
				}}>
				<ErrorOutline sx={{ mr: 1 }} />
				{title}
				<IconButton
					aria-label="close"
					onClick={onClose}
					sx={{
						color: 'error.contrastText',
						position: 'absolute',
						right: 8,
					}}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent>{children}</DialogContent>
		</Dialog>
	);
};
